import axios from '../config/axios.js'
const BASE_URL = '/api/college_manage'
export const classAnalysisServer = {
  queryGradeByProfessionId: (params) => {
    return axios.get(`${BASE_URL}/gradeAnalysis/queryGradeByProfessionId`, {params: params}).then(res => res.data)
  },
  queryGradeDirectoryById: (params) => {
    return axios.get(`${BASE_URL}/gradeAnalysis/queryGradeDirectoryById`, {params: params}).then(res => res.data)
  },
  queryGradeStudentRankList: (params) => {
    return axios.get(`${BASE_URL}/gradeAnalysis/queryGradeStudentRankList`, {params: params}).then(res => res.data)
  },
  queryGradeChapterList: (params) => {
    return axios.get(`${BASE_URL}/gradeAnalysis/queryGradeChapterList`, {params: params}).then(res => res.data)
  },
  queryQuestionList: (params) => {
    return axios.get(`${BASE_URL}/gradeAnalysis/queryQuestionList`, {params: params}).then(res => res.data)
  },
  queryStudyList: (params) => {
    return axios.get(`${BASE_URL}/gradeAnalysis/queryStudyList`, {params: params}).then(res => res.data)
  },
  queryGradeComparisonList: (params) => {
    return axios.get(`${BASE_URL}/gradeAnalysis/queryGradeComparisonList`, {params: params}).then(res => res.data)
  },
  queryQuestionDetail: (params) => {
    return axios.get(`${BASE_URL}/gradeAnalysis/queryQuestionDetail`, {params: params}).then(res => res.data)
  },
  queryStudyDetail: (params) => {
    return axios.get(`${BASE_URL}/gradeAnalysis/queryStudyDetail`, {params: params}).then(res => res.data)
  },
}



// WEBPACK FOOTER //
// ./src/api/server/classAnalysis.js